import { useAuthStore } from '../../stores/authStore'

const API_ORIGIN = import.meta.env.BACKEND_API_URL ?? ''

/**
 * Convert a recording_url from the API into a fully-qualified URL usable by
 * the browser (<video src> / download anchor).
 *
 * Backend returns recording_url as a relative path (e.g.
 * "/api/recordings/42/stream"); we prepend the API origin and append the
 * current JWT because the browser's <video> element can't add an
 * Authorization header.
 */
export function buildRecordingSrc(
  recordingUrl: string | null | undefined,
  opts?: { download?: boolean },
): string | null {
  if (!recordingUrl) return null
  if (!recordingUrl.startsWith('/api/recordings/')) return recordingUrl
  const token = useAuthStore.getState().token ?? ''
  const prefix = `${API_ORIGIN}${recordingUrl}`
  const params = new URLSearchParams({ t: token })
  if (opts?.download) params.set('download', '1')
  return `${prefix}?${params.toString()}`
}
